import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { AccountingBasisPrefs } from "src/app/store/models/right-panel-models";
import { AppService } from "src/app/app.service";
import { initialState } from "../../store/reducers/right-panel-reducer";

declare function gridRefresh(eventTarget, event);
declare function OnDefaultSetting(sectionName);

@Component({
  selector: "app-accounting-basis",
  templateUrl: "./accounting-basis.component.html",
  styleUrls: ["./accounting-basis.component.scss"],
  host: { class: "accounting-basis-component" },
  encapsulation: ViewEncapsulation.None,
})
export class AccountingBasisComponent implements OnInit {
  disabled = true;
  selectedValue = "All";
  valueSelected = false;
  storeSelectedValue: string;
  originalModel: AccountingBasisPrefs = { ...initialState.accountingBasis };
  tempModel: AccountingBasisPrefs = { ...initialState.accountingBasis };

  updateMEData_locally = false;

  constructor(private appService: AppService) {}

  ngOnInit() {
    window.addEventListener("MEDataSet", (rpObj: any) => {
      if (
        rpObj.detail.section === "Accounting basis" ||
        rpObj.detail.section === "All"
      ) {
        const data = this.getPanelData(rpObj.detail.data.panels);
        if (data !== undefined && !this.updateMEData_locally) {
          this.setAccountingBasisData(data);
        }
      }
    });
  }

  setAccountingBasisData(data) {
    this.originalModel = {
      clearDimension: data.clear_dimension,
      selected: data.selected,
    };
    this.tempModel = JSON.parse(JSON.stringify(this.originalModel));
    this.disabled = true;
  }

  onValueChange() {
    //update temp model on vaue
    this.disabled = this.appService.compare(this.originalModel, this.tempModel);
  }

  onApplyClick(evt) {
    const panelIdx = this.getIndexForPanel(window.MEData.panels);
    // used to show clear
    this.updateMEData_locally = true;
    this.updateMEData(this.tempModel);
    this.setAccountingBasisData(window.MEData.panels[panelIdx]);
    this.tempModel.clearDimension = true;
    setTimeout(() => {
      this.updateMEData_locally = false;
    }, 3000);
    gridRefresh(evt.currentTarget, evt);
  }

  onCancelClick() {
    const panelIdx = this.getIndexForPanel(window.MEData.panels);
    this.setAccountingBasisData(window.MEData.panels[panelIdx]);
  }

  resetToDefault() {
    this.tempModel.selected = "All";
    OnDefaultSetting("Accounting basis");
  }

  updateMEData(accountingBasis: AccountingBasisPrefs) {
    const panelIdx = this.getIndexForPanel(window.MEData.panels);
    window.MEData.panels[panelIdx] = {
      ...window.MEData.panels[panelIdx],
      selected: accountingBasis.selected,
    };
    window.gBasis = accountingBasis.selected;
  }

  handleClear(evt: MouseEvent) {
    //stop collapsing of inferred data section
    evt.stopImmediatePropagation();
    this.resetToDefault();
  }

  getPanelData(panelsList) {
    return panelsList.find(
      (panel) => panel.name.toLowerCase() === "accounting basis",
    );
  }

  getIndexForPanel(panelsList) {
    return panelsList.findIndex(
      (panel) => panel.name.toLowerCase() === "accounting basis",
    );
  }
}
